import { useState } from 'react'
import { Button, ContentCard, Grid, Group, Stack } from '@forwardflow/ui-v2'
import { ArrowLeftMdIcon, CloseIcon } from '@forwardflow/icons'
import { useCampaignStore } from '@forwardflow/store'
import { LeadSelection } from './LeadSelection'
import { TLeadType } from '@forwardflow/types/campaign.types'
import { useLeadOptions } from '@forwardflow/hooks/customHooks/useLeadOptions'

export const FilterConfirmation = ({
   setStep,
   selectedFilterId,
}: {
   setStep: (step: number) => void
   selectedFilterId: TLeadType
}) => {
   const { campaignConfiguration, setFirstFilterCriteria } = useCampaignStore()
   const { options } = useLeadOptions(selectedFilterId)

   const selectedValues =
      campaignConfiguration?.campaign_filters?.eligible_criteria[0]?.value || []
   const [selectedOptions, setSelectedOptions] =
      useState<Array<string | number>>(selectedValues)

   const [selectedValueId, setSelectedValueId] = useState<string | null>(null)
   const handleOptionSelect = (option: string) => {
      setSelectedOptions((prev) => {
         if (prev.includes(option)) return prev
         return [...prev, option]
      })
      setSelectedValueId(null)
   }
   const handleOptionRemove = (option: string) => {
      setSelectedOptions((prev) => prev.filter((o) => o !== option))
   }

   const handleConfirmSelection = () => {
      setFirstFilterCriteria({
         field: selectedFilterId as
            | 'source'
            | 'stage'
            | 'tags'
            | 'assigned_pond_id',
         value: selectedOptions.map((option) => option as string),
         logic: 'AND',
         operator: 'CONTAINS_ANY',
      })
      setStep(3)
   }

   return (
      <ContentCard className="space-y-4">
         <p className="text-white font-semibold text-lg">
            Which leads do you want Forward Flow to work on first?
         </p>
         <LeadSelection
            selectedFilterId={selectedFilterId}
            selectedValueId={selectedValueId}
            onOptionSelect={handleOptionSelect}
         />
         {selectedOptions.length > 0 && (
            <Stack>
               {selectedOptions.map((option, index) => (
                  <Group
                     key={index}
                     justify="space-between"
                     className="rounded-[8px] border border-[#A684FF]/30 bg-[#A684FF]/10 py-3 px-4"
                  >
                     <p className="text-white font-inter text-sm font-medium">
                        {selectedFilterId === 'assigned_pond_id'
                           ? options.find((i) => i.value === option)?.label
                           : option}
                     </p>
                     <CloseIcon
                        width={16}
                        height={16}
                        className="cursor-pointer"
                        onClick={() => handleOptionRemove(option as string)}
                     />
                  </Group>
               ))}
            </Stack>
         )}
         <Grid>
            <Grid.Col span={3}>
               <Button
                  variant="secondary"
                  className="w-full"
                  onClick={() => setStep(1)}
               >
                  <ArrowLeftMdIcon width={12} /> Back
               </Button>
            </Grid.Col>
            <Grid.Col span={9}>
               <Button
                  className="w-full"
                  disabled={selectedOptions.length === 0}
                  onClick={() => handleConfirmSelection()}
               >
                  Confirm Selection
               </Button>
            </Grid.Col>
         </Grid>
      </ContentCard>
   )
}
